var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"pointBar"},[_c('h3',{staticStyle:{"color":"#333333"}},[_vm._v("公司专利趋势")]),_c('div',{ref:"myScatter",staticClass:"myScatter",style:(`height: ${_vm.apiDataBarChart.companys.length*70}px`)})])
}
var staticRenderFns = []

export { render, staticRenderFns }